import React from "react";
import { Card } from "react-bootstrap";
import { CheckCircle } from "@material-ui/icons";
import Logo from '../../assets/img/logo.png';

class FormReceived extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {

    return (
      <div className="thank-you-msg-container">
        <div className="thank-you-msg">
          <img src={Logo} alt="logo" style={{ width: "500px", marginTop: "70px" }}/>
          <Card style={{ marginTop: "90px" }}>
            <span>
              <CheckCircle />
            </span>
            <div>
              Form received. Thanks! You can close this window now.
            </div>
          </Card>
        </div>
      </div>
    );
  }
}

export default FormReceived;